<template>
	<div class="home position-relative h-100">
		<div class="d-flex flex-column h-100">
			<div class="d-flex flex-column flex-grow-1 align-items-center">
				<div class="w-100 container content">
					<div class="interior">
						<div class="d-inline-block mb-5 cascade-1">
							<img src="../assets/images/logo.png" width="250">
						</div>
						<div class="display-1 mb-5 cascade-2" style="max-width: 800px;">Right Place, Right Time, Right Job.</div>
						<form class="home-search p-3 cascade-3" @submit.prevent="search">
							<div class="row">
								<div class="col p-0">
									<input class="w-100 border-right-0" type="text" placeholder="Job title, keywords" v-model="searchForm.keyword" />
								</div>
								<div class="col p-0">
									<input class="w-100 border-right-0" type="text" placeholder="City, state, zip code" v-model="searchForm.location" />
								</div>
								<div class="col-auto align-self-center pl-0 pr-0">
									<button type="submit" class="btn btn-primary rounded-0" v-bind:class="{ disabled: !canSearch() }" :disabled="!canSearch()">
										Search Jobs
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<footer class="d-flex w-100 home-footer position-absolute justify-content-center">
			<div class="container">
				<ul class="nav">
					<li class="nav-item">
						<div class="nav-link pl-0 pr-1">&copy; 2019 rightjobtoday.com</div>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" to="/privacy">Privacy Policy</router-link>
					</li>
					<li class="nav-item">
						<a class="nav-link" @click.prevent="openSupportForm" href="javascript: void(0)">Contact Us</a>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" to="/unsubscribe">Unsubscribe</router-link>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" to="/terms">Terms and conditions</router-link>
					</li>
				</ul>
			</div>
		</footer>
	</div>
</template>

<script>
export default {
  name: 'Homepage'
}
</script>

<style scoped lang="scss">
  .mjt-header__button {
    &.disabled {
      background-color: #ccc;
      &:hover {
        color: #fff;
      }
    }
  }
</style>
